import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { defineMessages, injectIntl } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import ArchivesDropDownNavigation from './archives_drop_down_navigation';
import {pick, every, isNil, negate, omitBy, isEmpty, isNumber} from 'lodash';

const ARCHIVES_STATE_KEYS = [
  'timestamp',
  'year',
  'month',
  'day'
];

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  pageTitle: {
    id: 'page_title',
    description: 'Translation for "Archives" page header on archives pages',
    defaultMessage: 'Archives'
  }
}));

const shouldRenderFormattedDate = ({ timestamp, year }) =>
  every([timestamp, year], negate(isNil));

const dateProps = ({ month, day }) =>
  omitBy({
    month: isNumber(month) && 'short',
    day: every([month, day], isNumber) && 'numeric'
  }, isEmpty);

const archivesTitle = ({ intl, ...props }) => {
  const i18nizedArchivesTerm = intl.formatMessage(i18nMessages.pageTitle);
  if (!shouldRenderFormattedDate(props)) {
    return i18nizedArchivesTerm;
  }
  const i18nizedDate = intl.formatDate(props.timestamp, {
    ...dateProps(props),
    year: 'numeric'
  });

  //on full date render date without `Archives - `
  if (props.day) {
    return `${i18nizedDate}`;
  }

  return `${i18nizedArchivesTerm} - ${i18nizedDate}`;
};

const shouldRenderNoResultsMessage =
  ({ timestamp, resultsCount }) =>
    !isNil(timestamp) && resultsCount === 0;

const noResultsMessage = () => (
  <div className="module notification">
    <RosettaFormattedMessage parentFilename={__filename}
      id="no_results"
      description="Message that appears on archives pages for which there are no entries"
      defaultMessage="Bummer! 0 results found"
    />
    <RosettaFormattedMessage parentFilename={__filename}
      id="find_more_stories_cta"
      description="Call to Action message to find more stories"
      defaultMessage="Let's find you something even more awesome."
    />
    <Link to="/">
      <button className="red pill">
        <RosettaFormattedMessage parentFilename={__filename}
          id="more_stories_button"
          description="Button linking to the homepage"
          defaultMessage="Today's Top Stories"
        />
      </button>
    </Link>
  </div>
);

export const ArchivesInterface = (props) => (
  <div>
    <ArchivesDropDownNavigation
      title={archivesTitle(props)}
      {...pick(props, ARCHIVES_STATE_KEYS)}
    />
    {shouldRenderNoResultsMessage(props) && noResultsMessage()}
  </div>
);

ArchivesInterface.propTypes = {
  timestamp: PropTypes.number,
  year: PropTypes.number,
  month: PropTypes.number,
  day: PropTypes.number,
  intl: PropTypes.shape({
    formatDate: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }),
  resultsCount: PropTypes.number.isRequired
};

export default injectIntl(ArchivesInterface);
